<template>
  <div class="querty_content queryCourse coursewareModle commonAddcourse">
    <!--面包屑-->
    <div class="crumbs">
      <!-- <span><router-link :to="{name:'Transition'}">首页</router-link></span> > -->
       <span>首页</span>>
      <span><router-link :to="{name:'ManageMeeting'}">专题读片</router-link></span> >
      <span>进入会议</span>
    </div>
    <div class="w98 course_query">
      <div class="course_top">
        <el-row>
          <el-col :span="7">
            <span class="manageTitle" :title="detailList.confName"  style="width:120px;overflow:hidden;
             text-overflow:ellipsis;white-space:nowrap;">{{ detailList.confName | lengthControl}}</span>
            <span class="managesm">{{this.detailList.openFlag}}</span>
          </el-col>
          <el-col :span="5" style="float:right;">
            <el-button  class="playback" @click="closeTopicConf">结束会议</el-button>
            <el-button @click="startView" class="playback">开启视频</el-button>
          </el-col>
        </el-row>
        <el-row style="padding-top: 15px;">
          <el-col :span="6">
            <span class="label_title">主持人：</span>
            <span class="info_content">{{this.detailList.host}}</span>
          </el-col>
          <el-col :span="6">
            <span class="label_title">会议名称：</span>
            <span class="info_content  info_contentName"
            :title="detailList.confName"
             style="width:120px;overflow:hidden;
             word-break: break-all;
             white-space: nowrap;
             text-overflow:ellipsis;white-space:nowrap;">{{this.detailList.confName | lengthControl}}</span>
          </el-col>
          <el-col :span="10">
            <span class="label_title">会议时间：</span>
            <span class="info_content">{{this.detailList.confTime}}</span>
          </el-col>
        </el-row>
        <el-row class="remarkTxt">
          <el-col :span="20">
            <span class="label_title">参会人员：</span>
            <span class="info_content dif_info"  :title="this.sendList" >{{this.sendListlitte}}</span>
          </el-col>
          <el-col :span="4">
            <el-dropdown class="members fr">
          <span class="el-dropdown-link">
           <el-badge :value="memberCount" class="item" :max="99">
             实际到会
            </el-badge>
            <i class="el-icon-arrow-down el-icon--right item"></i>
          </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in attendList" disabled>{{ item.docName }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </div>

      <div style="margin-top: 20px; width: 100%;" class="clearfix">
        <div class="query_medicalRecord_left">
          <tabs @tabChange="tabChange" :activeName="'0'">
              <!--附件-->
              <el-tab-pane name="0"  class="p-table-text">
                 <span slot="label">附件({{attachList.length}})</span>
               <div class="fj_contents">
                <div class="list_title list_file_title">
                  文件类型
                </div>
                <div class="query_medicalRecord_left_file_content">
                  <div v-if="fileList.length === 0" style="text-align:center;margin-top:10px;">暂无上传文件</div>
                  <div v-else>
                    <p class="file_row" v-for="(item, index) in fileList" :key="index" :class="{check: index == fileI}" @click="fileCLick('file', item, index)">{{item.attach_name}}</p>
                  </div>
                </div>
                <div class="list_title list_file_title">
                  其他图片
                </div>
                <div class="query_medicalRecord_left_file_content">
                  <div v-if="picList.length === 0" style="text-align:center;margin-top:10px;">暂无上传图片</div>
                  <div v-else>
                    <p class="file_row2" v-for="(item, index) in picList" :key="index" :class="{check: index == picI}" @click="fileCLick('img', item, index)">{{item.attach_name}}</p>
                  </div>
                </div>
               </div>
            </el-tab-pane>
            <el-tab-pane name="1" class="p-table-text">
              <!--影像-->
             <span slot="label">影像({{studyList.length}})</span>
                <div class="medicalList">
                  <reportTable :data="data1" :head="head1" class="img-table" @showDetial="studyShowDetials"></reportTable>
                </div>
              </el-tab-pane>
              <!--病例-->
               <el-tab-pane name="2">
                  <span slot="label">病例({{caseList.length}})</span>
                  <div class="medicalList selectClick dif_select">
                    <reportTable :head="head" :data="data"  @showDetial="showDetial"></reportTable>
                 </div>
               </el-tab-pane>
          </tabs>
        </div>
        <div class="query_medicalRecord_right query_course">
          <div v-if="isImage === '1'" class="reportContent">
            <h2><b>{{reportInfo.examTypeName}}</b>报告单
              <i class="btn btn2">电子病历</i>
              <i class="btn" @click="readFilm"  v-show="readFilmY">阅片</i>
              <i class="btn1"  v-show="readFilmN">阅片</i>
              <i class="btn btn3" @click="getReport">电子申请单</i>
            </h2>
            <report :info="reportInfo"></report>
          </div>
          <div class="file_area" v-if="isImage === '0'">
            <!--<div v-if="imgShow" class="img_area">-->
              <!--<img class="readImg" :src="url" alt="">-->
            <!--</div>-->
            <!--<iframe v-else width="100%" height="100%" :src="url" frameborder="0"></iframe>-->

             <div v-show="detailShow">
              <img width="100%" height="100%" src="../../../../static/image/defaultpic.png" alt="" >
              <p style="margin-top:23px; text-align:center">暂无内容</p>
            </div>
            <div v-if="imgShow=='2'" class="img_area">
              <img :src="fileUrl" alt="" @click="showBigImg()">
            </div>
            <div v-if="imgShow=='1'" class="file_show">
              <p class="tip">暂不支持预览，请点击下载</p>
              <a :href="fileUrl">下载</a>
            </div>
          </div>
          <div v-if="isImage === '2'">
              <div class="tabTwo">
                <tabs @tabChange="tabChangeRight" :activeName="'0'">
                  <el-tab-pane v-for="tab in tabsRight" :label="tab.label" :name="tab.name" :key="tab.name">
                    <!--病例信息-->
                    <div v-show="isImageTwo === '0'">
                      <medicalNewsDetail ref="child" :detailList="medicalDetail"></medicalNewsDetail>
                    </div>
                    <!--关联影像-->
                    <div v-show="isImageTwo === '1'" class="dif_select">
                      <p-table :head="head2" :data="data2" :operation="operation" @_operation="_operation_" :operationWidth="operationWidth"></p-table>
                    </div>
                    <!--病例附件-->
                    <div v-show="isImageTwo === '2'">
                      <uploadDetail :updateFileList="updateFileList" :updatePicList="updatePicList"></uploadDetail>
                    </div>
                  </el-tab-pane>
               </tabs>
             </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹出申请单 -->
    <pops v-if="repShow" :show="repShow" @closePop="closePop" :width="popwidth" :title="title" :classes="'Collections'" class="collect">
      <elcRep :elcRep="elcRep"></elcRep>
    </pops>
    <!-- 弹出图片 -->
    <pops v-if="filePop" :show="filePop" :title="''" @closePop="closeFile" :class="'mrDialog'" :width="'980px'">
      <img :src="fileUrl" width="100%" alt="">
    </pops>
     <!--结束会议按钮-->
    <aycanImages ref="aycanImages" :hospitalId='params_image.hospitalId' :studyPk='params_image.studyPk' :studyUid='params_image.studyUid' ></aycanImages>
  </div>
</template>

<script>
  import tabs from '@/components/common/tabs/tabs'
  import report from '@/components/common/report/publicReport'
  import pTable from '@/components/common/tables/publicTable'
  import reportTable from '@/components/common/tables/reportTable'
  import medicalNewsDetail from '@/components/common/medicalNews/medicalNewsDetail'
  import uploadDetail from '@/components/common/upload/uploadDetail'
  import elcRep from '@/components/common/report/electronicReport'
  import {getLocalStorage, saveLocalStorage} from '@/common/js/localStorage'
  import http from '@/api/http'
  import * as _ from "@/common/js/config"
  import {changehosArea,changeAge,changeGender,changeSex,yinyang,changeclinicType} from '@/common/js/change'
  import {nomalTime} from '@/common/js/time'
  import {message} from '@/common/js/messages'
  import pops from '@/components/common/pops/pop'

  import aycanImages from '@/components/common/base/aycanImages'
  export default {
    components: {
      tabs,
      report,
      reportTable,
      medicalNewsDetail,
      pTable,
      uploadDetail,
      elcRep,
      pops,
      aycanImages
    },
    data() {
      return {
        popwidth: '80%',
        isImage: '0',
        fileI:'',
        picI:'',
        isTime:false,
        fileUrl: '',
        filePop: false,
        scienceTypeData: '',
        imgShow: false,
        repShow: false,
        dataShow: false,
        detailShow:true,
         readFilmY:false,
        readFilmN:true,
        dataHide: true,
        isImageTwo: '0',
        detail: null,
        reportShow:　true,
        tH1: '100%',
        tH2: '100%',
        elcRep:{},
        operationWidth: '80px',
        detailList:{},
        fileList: [],
        picList: [],
        casedetailList1:[],
        readFirm: [],
        medicalDetail: {},
        confId: '',
        ConfPassword: '',
        thirdConfId: '',
        attachList:0, //附件的数量
        caseList:0, //病例的数量
        studyList:0, //影像的数量
        data1:[],
        token: '',       //视频token
        currentDate: '', //当前的时间
        endDate: '', //结束的时间
        hosSecond: '', //相差的毫秒数
        confChairName:'',//结束按钮是否显示
        closeBtnBool: false,//结束按钮是否显示
        userName: '',//登录用户的信息
        userID:'',  //登录用户id
        sendList: '',//参会人员
        sendListlitte: '',//参会人员省略显示
        memberCount: '',//实际到会人数
        attendList:[ //实际到会人员
          {
            userId: '刘医生',
            docName: '刘医生'
          },
          {
            userId: '李医生',
            docName: '李医生'
          }
        ],
        tabsRight: [
          {
            label: '病例信息',
            name: '0'
          }, {
            label: '关联影像',
            name: '1'
          },
          {
            label: '病例附件',
            name: '2'
          }
        ],
        tabs: [
            {
            label: '附件',
            name: '0'
          },
          {
            label: '影像',
            name: '1'
          }, {
            label: '病例',
            name: '2'
          },

        ],
        head1: [ //影像表格头部
          {
            props: 'mediId',
            label: '病案号',
            width: '25%'
          },
          {
            props: 'patientAge',
            label: '年龄',
            width: '13%'
          },
          {
            props: 'patientSex',
            label: '性别',
            width: '13%'
          },
          {
            props: 'examTypeName',
            label: '类型',
            width: '20%'
          },
          {
            props: 'examBodyName',
            label: '检查项目',
            width: '23%'
          }
        ],
        head: [
          {
            props: 'caseName',
            label: '病例名称',
            width: '20%'
          },
          {
            props: 'privateType',
            label: '访问权限',
            width: '15%'
          },
          {
            props: 'caseSex',
            label: '性别',
            width: '10%'
          },
          {
            props: 'caseAge',
            label: '年龄',
            width: '10%'
          }
        ],
        data: [],
        updateFileList:[],
        head2: [
          {
            props: "mediId",
            label: "病案号"
          },
          {
            props: "accessionNumber",
            label: "检查编号"
          },
          {
            props: "patientSex",
            label: "性别"
          },
          {
            props: "patientAge",
            label: "年龄"
          },
          {
            props: "examBodyName",
            label: "检查项目"
          }
        ],
        data2: [],
        updatePicList:[],
        reportInfo:{},
        operation: [
          {
            name: '阅片',
            operation: '',
            class: 'icon-yuepian'
          }
        ],
        params_image:{//阅片数据
          hospitalId:'',
          studyPk:'',
          studyUid:'',
        }
      }
    },
    filters:{
      lengthControl: (val)=>{
        if(val){
          if(val.length > 10){
            return val.substr(0, 10) + "..."
          }else{
            return val;
          }
        }

      }
    },
    beforeMount() {
      //设置定时器，每5秒刷新一次
      var self = this
      self.interVal = setInterval(updateConfMember,5000)
      self.timeVal = setInterval(updateVal,5000)
      function updateConfMember() {
          let attendListVal = []
          http.post('/conference/getTopicConfMemberList.json', {"id": self.confId }).then(res => {
            if (res.data.code === _.ERR_OK) {
              for(let item of res.data.model) {
                attendListVal.push({
                  userId: item.userId,
                  docName: item.docName
                })
              }
          }
          self.attendList = attendListVal
          self.memberCount = self.attendList.length
        })
      }
      //设置定时器，计算结束时间是否到
      function updateVal() {
        self.currentDate = new Date(); //取今天的日期

        //如果当前时间大于规定结束时间 弹出提示
        if(self.currentDate.getTime() > self.endDate && !self.isTime) {
          self.isTime = true;
          self.$alert('会议已超过预计用时', '提示').then(() => {
             //停止定时器 避免重复提示

              clearInterval(self.timeVal);
        }).catch(e=>{
           clearInterval(self.timeVal);
        })

        }
      }
    },
    beforeRouteLeave(to, form, next) { //离开页面时关闭定时器
      clearInterval(this.interVal)
      clearInterval(this.timeVal)
      next()
    },
    methods: {
      _operation_(payload) {
        if (payload.operation === 'icon-yuepian'){
          this.params_image.hospitalId = this.data2[payload.index].hospitalId;
          this.params_image.studyPk = this.data2[payload.index].studyPk+"";
          this.params_image.studyUid = this.data2[payload.index].studyUid;
          this.$nextTick(() => {
              this.$refs.aycanImages.getConsultImages();
            })
        //   let Aycan = {
        //     hospitalId:this.data2[payload.index].hospitalId,
        //     studyPk:this.data2[payload.index].studyPk,
        //     studyUid:this.data2[payload.index].studyUid,
        //   }
        //   http.post('/edu/prepareAycan.json', Aycan).then(res => {
        //     if (res.data.code == "0000") {
        //        let url = res.data.model

        //      window.open(res.data.model,'_blank');
        //   }else{
        //    alert('影像调阅失败',false);
        //   }
        // }).catch(() => {
        //   })
        }
      },
      readFilm() {
        //判断左边图标是否有值 没有的情况下点击阅片提示”当前并无数据“，有的话 按正常流程继续
        if( this.data1.length=== 0 ){
          message('当前并无数据',false);
          return;
        }
        this.params_image.hospitalId = this.readFirm.hospitalId;
        this.params_image.studyPk = this.readFirm.studyPk+"";
        this.params_image.studyUid = this.readFirm.studyUid;
        this.$nextTick(() => {
              this.$refs.aycanImages.getConsultImages();
            })
      //   let Aycan = {
      //     hospitalId:this.readFirm.hospitalId,
      //     studyPk:this.readFirm.studyPk,
      //     studyUid:this.readFirm.studyUid,
      //   }

      //   http.post('/edu/prepareAycan.json', Aycan).then(res => {
      //     if (res.data.code === "0000") {
      //     let url = res.data.model
      //     window.open(url)
      //   }else{
      //    message(res.data.msg,false)
      //   }
      // }).catch(() => {
      //   })
      },
      showBigImg() {
        this.filePop = true
      },
      closeFile() {
        this.filePop = false
      },
      fileCLick(type, obj, index) {

        if(type==='file'){
          this.fileI = index
          this.picI = null
        } else {

          this.fileI = null
          this.picI = index
        }
        // this.detailList = getLocalStorage('detail')
        let params = {
          refId: this.confId,
          businessType: 'conference'
        }
        http.post('system/getRelateAttachList.json', params).then(res => {

          if (res.data.code === _.ERR_OK) {
          if (obj.attach_type === 'file') {

            for (let item of res.data.model) {
              if (item.fileid === obj.fileid) {
                //this.url = encodeURI(`https://ow365.cn/?i=15894&furl=${item.fileurl}`)
                this.fileUrl = encodeURI(encodeURI(item.fileurl))
                this.imgShow = '1'
                this.detailShow=false
              }
            }
          } else {

            for (let item of res.data.model) {
              if (item.fileid === obj.fileid) {
                this.fileUrl = item.fileurl
                this.imgShow = '2'
              }
            }
          }
        }
      })
      },
      getFileVal(val) {

        let params = {
          refId: val,
          businessType: 'case'
        }
        http.post('system/getRelateAttachList.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
          this.updateFileList= []
          this.updatePicList = []
          for (let item of res.data.model) {
            if (item.attach_type === 'file') {
              this.updateFileList.push(item)
            } else {
              this.updatePicList.push(item)
            }
          }
        } else {
        }
      })
      },
      getReport() {
          return false;
      },
      closePop(val) {
        this.repShow = false
      },
      tabChange(payload) {
        this.isImage = payload.name
        if(this.isImage!=='1'){
          this.isImageTwo = '0'
          this.medicalDetail = {}
        }
      },
      tabChangeRight(payload) {
        this.isImageTwo = payload.name
      },
      showDetial(val) {
        this.medicalDetail = val
        this._getCaseDetail(val.id)
        this.getFileVal(val.id)
      },
      studyShowDetials(val) {
        this.readFilmY = true;
        this.readFilmN = false;
        this.report = { }
        this.readFirm.hospitalId = val.hospitalId
        this.readFirm.studyPk = val.studyPk
        this.readFirm.studyUid = val.studyUid
        if(val.reportState != '3') {
          message('该影像无报告',false)
          return false
        }
      
        //获取报告单详情
        let rep = {
          hospitalId: val.hospitalId,
          studyPk: val.studyPk,
          studyUid: val.studyUid,
        }
        http.post('/edu/reportDetail.json', rep).then(res => {
          // console.log(res.data)
          if (res.data.code == "0000") {
          res.data.model.studiesDoneDt = nomalTime(res.data.model.studiesDoneDt)
          res.data.model.reportSdt = nomalTime(res.data.model.reportSdt)
          res.data.model.approveDt = nomalTime(res.data.model.approveDt)
          res.data.model.reviseTime = nomalTime(res.data.model.reviseTime)
          res.data.model.patientSex = changeGender(res.data.model.patientSex)
          res.data.model.masculineFlag = yinyang(res.data.model.masculineFlag)
        /*   if(res.data.model.patientAge !== undefined) {
            res.data.model.patientAge = parseFloat(res.data.model.patientAge + changeAge(res.data.model.ageUnit))
          }else {
            res.data.model.patientAge = ''
          } */
          if (res.data.model.patientAge == undefined) {
              res.data.model.patientAge = ''
          }else if(res.data.model.patientAge.indexOf("岁") >0){
                   res.data.model.patientAge = res.data.model.patientAge
           }
          else {
               res.data.model.patientAge = res.data.model.patientAge + changeAge(res.data.model.ageUnit)
            }
          this.reportInfo= res.data.model
          this.ExamTypeName = res.data.model.examTypeName
          sessionStorage.setItem('zerRep',JSON.stringify(this.reportInfo))
        }
      }).catch(() => {
        })
      },
      closeTopicConf() { //结束会议
        http.post('/conference/closeTopicConf.json',{'id' : this.confId}).then(res => {
          if (res.data.code === _.ERR_OK) {
          message(res.data.msg, true)
          this.$router.go(-1)
        } else {
          message(res.data.msg, false)
        }
      }).catch(() => {})
      },
      startView() { //开启视频
        let startViewJson = {
          id: this.confId,
          confId: this.thirdConfId
        }

        http.post('/conference/startDailyConfView.json', startViewJson).then(res => {
          // console.log(res)
          if (res.data.code === _.ERR_OK) {
            let creator=res.data.model.creator
            // console.log('开启视频')
            // console.log(this.userName)
            let txtServerAddress = '114.55.29.216' //服务器地址
            let txtServerPort = '17979' //服务器端口
            let txtUserNickname = this.userName  //用户昵称
            let txtQuickUserID = '110' //用户ID
            let txtQuickConfID = this.thirdConfId //会议ID
            let txtUserRole = '1' //会议角色
            let txtQuickToken = this.token //Token
            let txtQuickrecordId = this.confId //会诊ID
            let txtQuickAddress = window.videoUrl //HTTP Server  //http://60.190.245.75:8080
            let txtQuickRequest = '/edu_web/video/videoRecodesave.json' //请求方法
           if (this.userID!=creator) {
                    txtQuickAddress = ''
                    txtQuickRequest = ''
             }
           alert('客户端正在启动，请稍候')
            let jsonText = this.getJsonTextQuickEnterConf(txtServerAddress, txtServerPort,
              txtUserNickname, txtQuickUserID, txtQuickConfID, txtUserRole
              , txtQuickToken, txtQuickrecordId, txtQuickAddress, txtQuickRequest)
            let jsonTextBase64 = this.base64encode(this.utf16to8(jsonText));
            this.executeAction(jsonTextBase64)
        } else {
          message(res.data.msg,false)
        }
      }).catch(() => {

        })
      },
      getJsonTextQuickEnterConf(serverAddress, serverPort, userNickname,userID, confID,UserRole,token,recordId,address,request) {
        var jsonText = '{' +
          '"Server": {' +
          '"Address": "' + serverAddress + '",' +
          '"Port": ' + serverPort +
          '},' +
          '"Action": {' +
          '"Name": "QuickEnterConf",' +
          '"Parameters": {' +
          '"UserName": "' + this.encodeUTF8(userNickname) + '"' +
          ',"UserID": '  + userID +
          ',"ConfID": ' + confID +
          ',"UserRole": ' + UserRole +','+
          '"Token": "' + token + '",' +
          '"RecordId": "' + recordId + '",' +
          '"Address": "' + address + '",' +
          '"Request": "' + request + '"' +
          '}' +
          '}' +
          '}';
        return jsonText;
      },
      encodeUTF8(str){
        var temp = "",rs = "";
        for( var i=0 , len = str.length; i < len; i++ ){
          temp = str.charCodeAt(i).toString(16);
          rs  += "\\u"+ new Array(5-temp.length).join("0") + temp;
        }
        return rs;
      },
      utf16to8(str) {
        var out, i, len, c;

        out = "";
        len = str.length;
        for (i = 0; i < len; i++) {
          c = str.charCodeAt(i);
          if ((c >= 0x0001) && (c <= 0x007F)) {
            out += str.charAt(i);
          } else if (c > 0x07FF) {
            out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
            out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
            out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
          } else {
            out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
            out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
          }
        }
        return out;
      },
      base64encode(str) {
        var base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var out, i, len;
        var c1, c2, c3;

        len = str.length;
        i = 0;
        out = "";
        while (i < len) {
          c1 = str.charCodeAt(i++) & 0xff;
          if (i == len) {
            out += base64EncodeChars.charAt(c1 >> 2);
            out += base64EncodeChars.charAt((c1 & 0x3) << 4);
            out += "==";
            break;
          }
          c2 = str.charCodeAt(i++);
          if (i == len) {
            out += base64EncodeChars.charAt(c1 >> 2);
            out += base64EncodeChars.charAt(((c1 & 0x3) << 4)
              | ((c2 & 0xF0) >> 4));
            out += base64EncodeChars.charAt((c2 & 0xF) << 2);
            out += "=";
            break;
          }
          c3 = str.charCodeAt(i++);
          out += base64EncodeChars.charAt(c1 >> 2);
          out += base64EncodeChars.charAt(((c1 & 0x3) << 4)
            | ((c2 & 0xF0) >> 4));
          out += base64EncodeChars.charAt(((c2 & 0xF) << 2)
            | ((c3 & 0xC0) >> 6));
          out += base64EncodeChars.charAt(c3 & 0x3F);
        }
        return out;
      },
      executeAction(jsonTextBase64) {
        var theResult = -1;
        $.ajax(
          {
            type: "GET",
            url: "http://127.0.0.1:17979/IMConf",
            data: "URL=IMConf://" + jsonTextBase64 + "/",
            dataType: "jsonp",
            //async: false,
            jsonp: "jsonpCallback",
            success: function (data) {
              theResult = 0;
              if (data.result != 0) {
                // console.log('成功啦')
                alert(data.message);
              }
            },
            error: function () {
              theResult = 0;
              // alert("ajax error!");
            }
          }
        );

        setTimeout(function () {
          if (theResult != 0) {
            alert("还没有安装客户端，请先下载视频客户端！");
          }
        }, 500);
      },
      getCookie(name){
        var strcookie = document.cookie;//获取cookie字符串
        var arrcookie = strcookie.split("; ");//分割
        //遍历匹配
        for ( var i = 0; i < arrcookie.length; i++) {
          var arr = arrcookie[i].split("=");
          if (arr[0] == name){
            return arr[1];
          }
        }
        return "";
      },
      _getCaseDetail(id) {
        http.post('/caselib/getCaseDetail.json', {id}).then(res => {
        if (res.data.code === _.ERR_OK) {
          this.data2 = []
          this.detail = res.data.model
          if (this.detail.ageUnit === '1') this.detail.ageUnit = '天'
          if (this.detail.ageUnit === '2') this.detail.ageUnit = '周'
          if (this.detail.ageUnit === '3') this.detail.ageUnit = '月'
          if (this.detail.ageUnit === '4') this.detail.ageUnit = '岁'
          if (this.detail.ageUnit === '5') this.detail.ageUnit = '小时'
           for (let item of this.detail.studyList) {
               item.patientSex = changeGender(item.patientSex)
               item.hosArea = changehosArea(item.hosArea)
               if (item.patientAge == undefined) {
                  item.patientAge = ''
                } else if(item.patientAge.indexOf("岁") >0) {
                  item.patientAge = item.patientAge
                }else{
                  item.patientAge = item.patientAge + changeAge(item.ageUnit)
                }
           }
          this.data2 = this.detail.studyList
        }
      })
      }
    },

    mounted() {
      //登录用户信息
      http.post('/getUserInfo.json').then(res => {
        if (res.data.code === _.ERR_OK) {
          this.confChairName = res.data.model.userName
          // this.confTime=res.data.model.doctorSign

        }
        }).catch(() => {

       })
      // console.log(this.detailList.host)
       if(this.confChairName == this.detailList.host) {
          this.closeBtnBool = true
         // console.log(this.closeBtnBool)
       } else {
         this.closeBtnBool = false
         // console.log(this.closeBtnBool)
       }
    },
    created() {
      this.token = this.getCookie('eimageglobaltid') //视频token
      this.confId = getLocalStorage('idVal')
      this.ConfPassword = getLocalStorage('ConfPasswordVal')
      let params = {
        id: this.confId,
        confPwd: this.ConfPassword
      }
      this.sendList = ''
      http.post('/conference/getTopicConfDetail.json', params).then(res => {
        if (res.data.code === _.ERR_OK) {
          this.studyList=res.data.model.studyList
          this.attachList=res.data.model.attachList
          this.caseList=res.data.model.caseList
        //   console.log('=======')
        // console.log(this.confChairName)
        if(this.confChairName == res.data.model.confChairName) {
          this.closeBtnBool = true
        } else {
          this.closeBtnBool =false
        }

        this.thirdConfId = res.data.model.confId
        this.detailList.confName = res.data.model.confName
        this.detailList.host = res.data.model.confChairName
        this.detailList.confTime = res.data.model.startDateStr+'-'+res.data.model.endDateStr.slice(res.data.model.endDateStr.indexOf(' ')+1 , res.data.model.endDateStr.length)
        let now = this.detailList.confTime;

        //this.updateVal()
        // if (res.data.model.endDateStr>now) {
        //     // console.log("0000000")
        //    // this.form.startDateStr = '';
        //    alert('会议已超过预计用时!')
        //   }else{
        //      alert('会议没有超过预计用时!')
        // }
        if(res.data.model.openFlag == '1') {
          this.detailList.openFlag = '公开'
        } else {
          this.detailList.openFlag = '私密'
        }
        var examinePart = "";   //开放范围修改部分
        let par = {}
        for (let item of res.data.model.attendList) {
          if(item.attendType == '3'){
            par = {
              id: item.groupId,
              name: item.groupName,
              job: '',
              attebdType: item.attendType
            }
          }else if(item.attendType =='2'){
            par = {
              id: item.hosId,
              name: item.hosName,
              job: '',
              attebdType: item.attendType
            }
          }else if(item.attendType =='1'){
            par = {
              id: item.deptId,
              name: item.deptName,
              job: item.hosName,
              attebdType: item.attendType
            }
          }else{
            par = {
              id: item.userId,
              name: item.userName,
              job: item.docTitle,
              attebdType: item.attendType
            }
          }
          examinePart +="，" + par.name;
          if (examinePart.substr(0,1)=='，')
            examinePart=examinePart.substr(1);
        }
        this.sendList = examinePart
        if(this.sendList.length > 115) {
          this.sendListlitte = this.sendList.slice(0,115)
          this.sendListlitte = this.sendListlitte + '...'
        } else {
          this.sendListlitte = this.sendList
        }
        this.memberCount = res.data.model.attendMemberList.length
        this.attendList = res.data.model.attendMemberList
        this.data1 = res.data.model.studyList
        for(let item of this.data1) {
          if(item.patientSex == 'F') {
            item.patientSex = '女'
          } else {
            item.patientSex = '男'
          }
           if (item.patientAge == undefined) {
              item.patientAge = ''
            } else if(item.patientAge.indexOf("岁") >0){
             item.patientAge = item.patientAge
            }
            else {
             item.patientAge = item.patientAge + changeAge(item.ageUnit)
            }
        }

        for (let item of res.data.model.caseList) {
          if(item.caseSex === '1') {
            item.caseSex = '男'
          } else {
            item.caseSex = '女'
          }
          if(item.privateType === 0) {
            item.privateType = "公共"
          } else if(item.privateType === 1) {
            item.privateType = "个人"
          } else if(item.privateType === 2) {
            item.privateType = "部门公开"
          } else if(item.privateType === 3) {
            item.privateType = "医院公开"
          }
          if (item.caseAge == undefined) {
                  item.caseAge = ''
          } else if(item.caseAge.indexOf("岁") >0) {
                  item.caseAge = item.caseAge
          }else{
                  item.caseAge = item.caseAge + changeAge(item.ageUnit)
          }
        }
        this.data = res.data.model.caseList
        //附件
        if (res.data.model.attachList.length > 0) {
          for (let item of res.data.model.attachList) {
            if (item.attach_type === 'file') {
              this.fileList.push(item)
            } else {
              this.picList.push(item)
            }
          }
        }
        //结束时间
        // this.endDate = new Date((res.data.model.endDateStr + ':00').replace("-","/"))
        this.endDate = res.data.model.endDate;
        this.currentDate = new Date(); //取今天的日期
        // let endDateVal = this.endDate.replace("-","/")
        // this.hosSecond = new Date(Date.parse(endDateVal)).getTime() - this.currentDate.getTime()
        // console.log('毫秒数======')
        // console.log(this.hosSecond)
      }
    })

      http.post('/getUserInfo.json').then(res => {
        // console.log('登录用户信息')
        // console.log(res)
        if (res.data.code === _.ERR_OK) {
        this.userName = res.data.model.userName
        this.userID=res.data.model.userId
      }
    }).catch(() => {

      })


    },
    name: "query-medical-record-info",

  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .commonAddcourse
    height: calc(100vh - 50px)
    overflow-y: auto
  .querty_content
    width: 100%
  .item
    color:$color-green
  .btn-box
    text-align: center
    margin: 20px 0
  .overConf
    width: 180px
    height: 35px
    border: none
    background: $color-text-hover
    color: $color-background-d
  .manageTitle
    float: left
    line-height: 30px
    font-size: 18px
    color: #000
    margin-left: 20px
    width: auto
  .managesm
    float: left;
    line-height: 20px
    width: 40px
    height: 20px
    background: #ccc
    color: #fff
    text-align: center
    border-radius: 5px
    margin: 5px 0 0 5px
  .playback
    float: right
    margin: 5px 20px 0 0
    width: 90px
    text-align: center
    height: 30px
    line-height: 30px
    cursor: pointer
    border-radius: 4px
    background: #00abad
    color: #fff
    font-size: 14px
  .course_top
    background: #fff
    overflow-y: auto

  .label_title
    display: block
    width: 110px
    text-align: right
    float: left
  .info_content:hover
    display: block
    width: calc(100% - 120px)
    float: left
    overflow: visible
    color: #000

  .query_medicalRecord_left
    background: #fff
    float: left
    width: 30%
    margin-bottom: 20px
    height calc(100vh - 250px)

  .file_area
    height: calc(100vh - 250px)
    display:flex ;
    align-items :center;
    justify-content :center;

  .file_show a
    display:block
    width: 80px
    height: 27px
    line-height:27px
    cursor: pointer
    background: #01abac
    color: #fff
    border-radius: 3px
    text-align: center
    margin:10px auto 0

  .tip
    text-align:center
    font-size:100%

  .query_medicalRecord_left_image_content
    height: calc(100vh - 355px)
    overflow-y: auto


  .tabTwo
    padding 0 20px
    height: calc(100vh - 250px)
  .query_medicalRecord_right
    background: #fff
    float: right
    width: 68%
    margin-bottom: 20px

  .check
    background : #e2e8f6;

  .query_medicalRecord_left_content
    // height: 450px
    overflow-y: height

  .list_title
    height: 36px
    line-height: 36px
    background: #8791a2
    color: #fff
    span
      display: inline-block
      text-align: center
      overflow: hidden
      text-overflow : ellipsis
      white-space : nowrap
      font-weight: 900

  .list_cell
    height: 36px
    line-height: 36px
    span
      display: inline-block
      text-align: center
      overflow: hidden
      text-overflow : ellipsis
      white-space : nowrap

  .list_cell:hover
    background: #f0f0f0

  .cell_dark
    background: #7e8c8d

  .dif_info
    width: 84% !important
    line-height: 18px
    margin-top: -2px

  .cell_light
    background: #fff

  .dataHide
    line-height: calc(100vh - 355px)
    text-align: center

  .remarkTxt
    padding-bottom: 8px

  .readImg
    max-width: 100%
    max-height: 90%

  .query_medicalRecord_left_file_content
    height: calc((100vh - 250px - 60px)*0.5 - 36px )
    overflow-y: auto

  .list_file_title
    text-indent: 14px
    height 100%
    font-weight: 900
  .fj_contents
    height
  .dif_cont
    width: 100%
    position: relative
    top: -18px
    left: 110px
    height: 26px
    overflow: hidden
    white-space:nowrap
    text-overflow:ellipsis
    cursor: pointer
    .range_cont
      line-height: 23px
  .reportContent
    height: calc(100vh - 250px)
    overflow-y: auto
    b
      font-weight bold
    h2
      font-size: 16px
      color: #000
      font-weight bold
      text-align: center
      position: relative
      line-height 40px
      height 40px
    .btn
      position: absolute;
      width: 90px;
      text-align: center;
      height: 30px;
      line-height: 30px;
      top: 5px;
      right: 10px;
      cursor: pointer;
      border-radius: 4px;
      background: #00abad;
      color: #fff;
      font-size: 14px
    .btn2
      background : #aaadb3
      right: 110px !important
    .btn3
      background :#aaadb3
      right: 210px !important
    .btn1
      position: absolute;
      width: 90px;
      text-align: center;
      height: 30px;
      line-height: 30px;
      top: 5px;
      right: 10px;
      cursor: pointer;
      border-radius: 4px;
      background : #aaadb3;
      color: #fff;
      font-size: 14px   

  .file_row,.file_row2
    height : 36px
    line-height : 36px
    text-indent: 10px
    width 100%
    overflow:hidden
    white-space:nowrap
    text-overflow:ellipsis
    cursor :pointer
  .file_row:hover
    background :#f0f0f0
  .file_row2:hover
    background :#f0f0f0
  .img_area
    width : 80%
    height : 100%
    text-align :center
    img
      margin-top : 5%;
      max-width 100%
      max-height 90%
    /*病例*/
  .medicalList
    height calc(100vh - 180px - 90px - 33px)
  .report-content table tr td p
    display: flex;
    display: -ms-flexbox;
    color: #000;
    font-size: 13px;
    /* line-height: 30px; */
    min-height: 34px;
    height: 100%;
    border-left: 1px solid #dcdee1;
    width: calc(100% - 104px);
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-align: -ms-center;
    align-items: -ms-center;
    float: left;
    /* padding: 2px 0 2px 6px; */
    box-sizing: border-box;

</style>



// WEBPACK FOOTER //
// enterManageMeeting.vue?02ff80e3